import { Button } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

const UniButton = withUnistyles(Button)

export default UniButton
